module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center has-padding-top"
  }, [_c('ul', {
    staticClass: "pagination"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onPageChange(_vm.current - 1)
      }
    }
  }, [_vm._v("‹")])]), _vm._v(" "), _vm._l((_vm.pagesCount), function(n) {
    return _c('li', {
      class: {
        'active': _vm.current == n
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onPageChange(n)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(n))])])
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onPageChange(_vm.current + 1)
      }
    }
  }, [_vm._v("›")])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b2a8308","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pagination.vue
// module id = 360
// module chunks = 0